import React, { useEffect, useState, useCallback } from 'react';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { Dialog, DialogContent } from '@mui/material';

import api from 'stores/api';
import NotePopup from '../NotePopup';
import NoteContent from '../NoteContent';

import styles from './styles';
import acl from 'constants/acl';

const dialogContentStyles = {
  padding: 0,
};

function ShipmentNote(props) {
  const { shipmentId, store } = props;
  const { permissionStore, userStore } = store;
  const { user } = userStore;
  const userId = user.id;

  const [content, setContent] = useState('');

  const [notes, setNotes] = useState([]);
  const [isEnableEdit, setIsEnableEdit] = useState(false);
  const [isEditForm, setIsEditForm] = useState(false);
  const [isShowPopup, setIsShowPopup] = useState(false);

  const isDenied = permissionStore.isDenied(acl.ASSIGNMENTS.NOTE);

  const addFnc = () => {
    if (isDenied) return;

    setIsEditForm(false);
    setIsShowPopup(true);
    setContent('');
  };

  const editFnc = () => {
    if (isDenied) return;

    const lastNote = notes.find((note) => note.subject.uid === `US_${userId}`);
    if (lastNote) {
      setIsEditForm(true);
      setContent(lastNote.content);
      setIsShowPopup(true);
    }
  };

  const loadData = useCallback(() => {
    api.get(`/notes/SH_${shipmentId}`).then((resp) => {
      if (resp.ok) {
        if (resp.data && resp.data.length > 0) {
          setNotes(resp.data);
          const lastNote = resp.data.find((note) => note.subject.uid === `US_${userId}`);
          if (lastNote) {
            setIsEnableEdit(true);
          } else {
            setIsEnableEdit(false);
          }
        } else {
          setNotes([]);
        }
      } else {
        setNotes([]);
      }
    });
  }, [shipmentId, userId]);

  const editContent = (content) => {
    api.put(`/notes/SH_${shipmentId}`, content, { headers: { 'Content-Type': 'text/plain' } }).then((resp) => {
      if (resp.ok) {
        loadData(shipmentId, userId);
      }
      setIsShowPopup(false);
    });
  };

  const saveContent = (content) => {
    api.post(`/notes/SH_${shipmentId}`, content, { headers: { 'Content-Type': 'text/plain' } }).then((resp) => {
      if (resp.ok) loadData(shipmentId, userId);
      setIsShowPopup(false);
    });
  };

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div style={styles.container}>
      <NoteContent title="Shipment Note" notes={notes} editFnc={editFnc} addFnc={addFnc} isEnableEdit={isEnableEdit} />
      <Dialog open={isShowPopup} maxWidth="sm" fullWidth onClose={() => setIsShowPopup(false)}>
        <DialogContent sx={dialogContentStyles}>
          <NotePopup
            title={isEditForm ? 'Edit Last Shipment Note' : 'Shipment Note'}
            isEditForm={isEditForm}
            content={content}
            closePopup={() => setIsShowPopup(false)}
            saveContent={saveContent}
            editContent={editContent}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default compose(inject('store'), observer)(ShipmentNote);
